/// <reference path="../_all.ts" />

module part {
  'use strict';

  
  export function partsByGroupAndCatFilter() {



    var matchQuery = (reference: ArtikelReferenz2Object, partsearch: string, partData: ServiceData, partNoPropertyName : string, productNoPropertyName : string) => {
      if (!partsearch) return false;


      partsearch = partsearch.toLowerCase();
      if (reference[partNoPropertyName] && reference[partNoPropertyName].indexOf(partsearch) >= 0) return true;

      //Part 
      if (reference[partNoPropertyName]) {
        var p : Part = partData.Parts[reference[partNoPropertyName]];
        if (p.TextD.toLowerCase().indexOf(partsearch) >= 0) return true;
        if (p.TextE.toLowerCase().indexOf(partsearch) >= 0) return true;
        if (p.TextF.toLowerCase().indexOf(partsearch) >= 0) return true;
      }

      //Product 
      if (reference[productNoPropertyName]) {
        var prod: Product = partData.Products[reference[productNoPropertyName]];
        if (prod.Name.toLowerCase().indexOf(partsearch) >= 0) return true;
        if (prod.TextD && prod.TextD.toLowerCase().indexOf(partsearch) >= 0) return true;
        if (prod.TextE && prod.TextE.toLowerCase().indexOf(partsearch) >= 0) return true;
      }

      return false;
    };



    return function (references: ArtikelReferenz2Object[]
      , cat: ArtikelReferenzKategorie
      , group: ArtikelReferenzGruppe
      , partsearch: string
      , partData : ServiceData
      , queryPrio : boolean) { //items, search

      references = references || [];
      if (!cat) return [];
      if (!group) return [];
      var out = [];

      references.forEach(function (reference : ArtikelReferenz2Object) {
        
        var partNoPropertyName = reference.hasOwnProperty('ItemNo') ?  'ItemNo' : 'Part';
        var productNoPropertyName = reference.hasOwnProperty('ProduktNummer') ?  'ProduktNummer' : 'Product';

        if (queryPrio && partsearch) {
          if (matchQuery(reference, partsearch, partData, partNoPropertyName, productNoPropertyName)) {
            out.push(reference);
            return;
          }
        }

        if (partNoPropertyName = 'ItemNo') {//artikelreferenz
          if (reference.KategorieNummer == cat.Nummer
            && reference.GruppeNummer == group.Nummer
            && (!cat.DifferentiateGroups || cat.Grundausstattung == reference.Grundausstattung)) {
            
            if (!partsearch) out.push(reference);

            if (matchQuery(reference, partsearch, partData, partNoPropertyName, productNoPropertyName)) {
              out.push(reference);
            }
          }
        }

      });
      return out;
    }
  }


}